<template lang="pug">
div.container
  div.header
      img( src="@/assets/gps-logo.svg" )
      span.ml-2.text-22-b Где нас найти?
  #map
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "YandexMap",

  data() {
    return {
      map: null,
    };
  },

  computed: {
    ...mapState("maps", ["listGeoData"]),
  },

  mounted() {
    this.loadYandexMaps();
  },

  methods: {
    backPage() {
      this.$router.back()
    },

    loadYandexMaps() {
      if (window.ymaps) {
        this.initMap()
        return
      }

      const script = document.createElement("script")
      script.src = "https://api-maps.yandex.ru/2.1/?apikey=51eb9910-6a88-4d6e-b494-36cff42bc1ea&lang=ru_RU"
      script.async = true;
      script.onload = () => window.ymaps.ready(this.initMap)
      document.head.appendChild(script)
    },

    initMap() {
      this.map = new window.ymaps.Map("map", {
        center: [51.1605, 71.4704],
        zoom: 12,
        controls: ["zoomControl", "geolocationControl"],
      });

      if (this.listGeoData?.point?.length) {
        this.addPlacemarks(this.listGeoData.point)
      }
    },

    addPlacemarks(points) {

      points.forEach((item) => {
        const lat = parseFloat(item.lat)
        const lon = parseFloat(item.lon)

        if (isNaN(lat) || isNaN(lon)) return

        const placemark = new window.ymaps.Placemark(
          [lat, lon],
          {
            balloonContentHeader: item.title,
            balloonContentBody: item.info,
            balloonContentFooter: item.type,
          },
          {
            preset: "islands#blueDotIcon",
            balloonMaxWidth: 300,
          }
        );

        this.map.geoObjects.add(placemark)
      })
    }

  },
};
</script>

<style scoped>
html, body, #app {
  height: 100%;
  margin: 0;
}

.header {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 16px;
  gap: 12px;
}

.container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  gap: 16px;
}

#map {
  height: 100%;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 72px;
}
</style>